<script setup lang="ts">
import Button from 'primevue/button';

import { useDownloadCalculationSummaryCsv } from '@/composables/useDownloadCalculationSummaryCsv';

const { downloadCalculationSummaryCsv, hasRows } = useDownloadCalculationSummaryCsv();
</script>

<template>
  <Button
    class="font-semibold"
    severity="secondary"
    outlined
    size="small"
    :disabled="!hasRows"
    @click="downloadCalculationSummaryCsv"
  >
    <i class="pi pi-download"></i>
    Zapisz podsumowanie do CSV
  </Button>
</template>
